import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Col } from 'antd';
import { keyBy, find, get, filter } from 'lodash';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import helpers from 'utils/helpers';
import currency from 'utils/currency';
import { getInfoRequest } from 'ducks/users';
import { getOrderRequest } from 'ducks/shipments';

import {
  WrapperDiv,
  ShipmentRow,
  ChargeRow,
  StyledPopup
} from 'components/Styled';
import CheckoutForm from './CheckoutForm';
import AddressCard from './AddressCard';
import RedirectPopup from './RedirectPopup';
import ImagePlane from 'assets/images/plane.svg';
import countries from 'data/countries';
import InfoBar from 'components/common/InfoBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popup from 'components/common/Popup';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventScroll50: false,
      eventScroll90: false,
      scrollInit: true,
      coupon: '',
      discount: null,
      redirectUrl: null,
      interval: null
    };

    this.pricing = React.createRef();
    this.handleCharge(props.pickupData, props.shipmentData);
  }

  handleRadioChange = _code => {
    const coupon = find(this.props.coupons, ['code', _code]);
    const { type, value, code } = coupon || {};

    let discount = null;

    switch (type) {
      case 'fixed': {
        discount = value;
        break;
      }
      case 'percentage': {
        const {
          totalRate,
          otherCharges,
          naturalAmount
        } = this.props.shipmentData;
        const baseAmount = naturalAmount
          ? naturalAmount?.totalRate - naturalAmount?.otherCharges
          : totalRate - otherCharges;
        discount = Number((baseAmount * value * 0.01).toFixed(2));
        break;
      }
      default: {
        break;
      }
    }

    this.handleDiscount(code || '', discount);
    this.setState({
      coupon: code || '',
      discount
    });
  };

  handleScroll = () => {
    const el = window.document.scrollingElement;

    const maxScroll = el.scrollHeight - el.clientHeight;

    if (el.scrollTop < maxScroll * 0.5 && this.state.scrollInit) {
      // prevent smooth scroll to activate the triggers
      this.setState({
        eventScroll50: true,
        eventScroll90: true,
        scrollInit: false
      });
    }

    if (el.scrollTop >= maxScroll * 0.5 && this.state.eventScroll50) {
      window.dataLayer.push({
        event: 'Payment Scroll 50',
        ecommerce: undefined
      });
      this.setState({
        eventScroll50: false
      });
    }

    if (el.scrollTop >= maxScroll * 0.9 && this.state.eventScroll90) {
      window.dataLayer.push({
        event: 'Payment Scroll 90',
        ecommerce: undefined
      });
      this.setState({
        eventScroll90: false
      });
    }
  };

  openStaticPopup = popups => {
    this.setState({
      popupKey: !this.state.popupKey,
      popups
    });
  };

  handleDrawerClose = () => {
    this.setState({
      redirectUrl: null
    });

    clearInterval(this.state.interval);
  };

  getVolumeWeightPopup = () => {
    const baseUrl =
      'https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/volume-weight-explain';

    return [
      {
        id: 0,
        content: (
          <StyledPopup>
            <div className="subtitle">
              {this.props.t('popup.volume_weight_explain.subtitle')}
            </div>
            <div className="title buttonTheme-color">
              {this.props.t('popup.volume_weight_explain.title')}
            </div>
            <div style={{ textAlign: 'center', padding: '20px 0 20px 10px' }}>
              <img
                src={`${baseUrl}-${this.props.t('key')}.png`}
                srcSet={`
                ${baseUrl}-${this.props.t('key')}.png 1x,
                ${baseUrl}-2x-${this.props.t('key')}.png 2x,
                ${baseUrl}-3x-${this.props.t('key')}.png 3x
                `}
              />
            </div>
          </StyledPopup>
        )
      },
      {
        id: 1,
        content: (
          <StyledPopup>
            <div className="subtitle">
              {this.props.t('popup.volume_weight_explain_2.subtitle')}
            </div>
            <div className="title buttonTheme-color">
              {this.props.t('popup.volume_weight_explain_2.title')}
            </div>
            <div style={{ textAlign: 'center', padding: '20px 0 20px 10px' }}>
              <img
                src={`https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}.png`}
                srcSet={`
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}.png 1x,
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}%402x.png 2x,
                https://spaceship-product-images.s3.ap-east-1.amazonaws.com/post_feature_images/calculation-${this.props.t(
                  'key'
                )}%403x.png 3x
                `}
              />
            </div>
            <div>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.t('popup.volume_weight_explain_2.body')
                }}></span>
            </div>
          </StyledPopup>
        )
      }
    ];
  };

  handleNext = () => {
    this.props.handleNext({
      orderRef: this.props.orderRef,
      discount: this.pricing?.current?.discount,
      coupon: this.state.coupon,
      pickupNumber: this.props.pickupNumber
    });

    this.props.getInfoRequest({ user: this.props.user });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.paymentSuccess && this.props.paymentSuccess) {
      if (
        this.props.paymentStatus === 'PENDING' &&
        this.props.paymentMethodData.redirectUrl
      ) {
        // permanent redirect
        if (this.props.paymentMethodData.paymentMethod === 'alipayGlobalWap') {
          return this.props.handler.saveOrderState(
            this.props.paymentMethodData.redirectUrl,
            {
              orderRef: this.props.orderRef,
              discount: this.state.discount,
              coupon: this.state.coupon,
              pickupNumber: this.props.pickupNumber
            },
            this.props.props
          );
        }

        const interval = setInterval(() => {
          return this.props.getOrderRequest({
            orderRef: this.props.orderRef
          });
        }, 3000);

        return this.setState({
          interval,
          redirectUrl: this.props.paymentMethodData.redirectUrl,
          paymentMethod: this.props.paymentMethodData.paymentMethod
        });
      }

      // this.handleNext();
      // Refresh order detail
      return this.props.getOrderRequest({
        orderRef: this.props.orderRef
      });
    }

    if (!prevProps.getOrderSuccess && this.props.getOrderSuccess) {
      if (
        this.props.paymentStatus === 'PAID' ||
        this.props.transactionStatus === 1 // Bypass user did not have paymentstatus
      ) {
        this.handleDrawerClose();

        setTimeout(this.handleNext, 200);
      }
    }
  }

  componentDidMount() {
    window.dataLayer.push({
      event: 'Land Payment Page',
      ecommerce: undefined
    });

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    this.props.handler.openPopup(filter(this.props.posts, ['page', 'PAYMENT']));
    this.props.handler.clearOrderStorage();
    this.handleDiscount('');
  }

  handleDiscount(couponCode, discountValue) {
    const coupon = find(this.props.coupons, ['code', couponCode]);
    const { type, amount, value } = coupon || {};

    const { pickupFee } = this.props.pickupData || {};
    const { totalRate, otherCharges, naturalAmount } = this.props.shipmentData;

    let discount =
      this.pricing?.current?.discount ||
      new currency({ amount: 0, minor: 2, currency: this.props.currency });

    switch (type) {
      case 'fixed':
        discount.amount = amount?.amount || value * 100;
        discount.minor = amount?.minor || discount.minor;
        discount.currency = amount?.currency || this.props.currency;
        break;
      case 'percentage':
        {
          const percentageRate = value * 0.01;
          discount = new currency(totalRate)
            .subtract(new currency(otherCharges))
            .multiply(percentageRate);
        }
        break;
      default:
        discount.amount = 0;
        discount.currency = this.props.currency;
        discount.minor = 2;
        break;
    }

    this.pricing.current = {
      ...(this.pricing.current || {}),
      discount,
      finalRate: new currency(totalRate || 0)
        .add(pickupFee || 0)
        .subtract(discount),
      finalRateInHKD: new currency(naturalAmount?.totalRate || 0)
        .add(naturalAmount?.pickupFee || 0)
        .subtract(discountValue * 100)
    };
  }

  handleCharge(pickupData, shipmentData) {
    let pricing = {};

    if (pickupData && shipmentData) {
      const { pickupFee } = pickupData || {};

      const {
        totalRate,
        naturalAmount,
        freightCharge,
        fuelSurcharge,
        otherCharges
      } = shipmentData || {};

      pricing = {
        ...pricing,
        pickupFee: new currency(pickupFee || 0),
        freightCharge: new currency(freightCharge || 0),
        fuelSurcharge: new currency(fuelSurcharge || 0),
        otherCharges: new currency(otherCharges || 0),
        totalRate: new currency(totalRate || 0),
        totalRateInHKD: new currency(naturalAmount?.totalRate || 0),
        finalRate: new currency(totalRate || 0).add(pickupFee || 0),
        finalRateInHKD: new currency(naturalAmount?.totalRate || 0).add(
          naturalAmount?.pickupFee || 0
        )
      };
    }

    this.pricing.current = {
      ...(this.pricing?.current || {}),
      ...pricing
    };
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  infoBarTitle = () => {
    let raw = this.props.t('payment.reminder_title');
    return {
      __html: raw
    };
  };

  infoBarContent = () => {
    let raw = this.props.t('payment.reminder');
    return {
      __html: raw
    };
  };

  render() {
    if (this.props.redirect) {
      this.props.history.replace(
        `${process.env.PUBLIC_URL}/create-shipment/quotation`
      ); // redirect to step 1 from direct url
      return null;
    }
    const minDatetime = moment(
      get(this.props.pickupData, 'minDatetime')
    ).utcOffset(process.env.REACT_APP_SERVER_UTC_OFFSET);
    const maxDatetime = moment(
      get(this.props.pickupData, 'maxDatetime')
    ).utcOffset(process.env.REACT_APP_SERVER_UTC_OFFSET);

    const countriesData = keyBy(this.props.countries, 'alpha-2');

    return (
      <div
        className="quotation-content"
        style={{
          margin: '0 auto',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <RedirectPopup
          t={this.props.t}
          visible={!!this.state.redirectUrl}
          redirectUrl={this.state.redirectUrl}
          paymentMethod={this.state.paymentMethod}
          onClose={this.handleDrawerClose}
        />
        <WrapperDiv style={{ padding: '25px 0 30px' }}>
          <a onClick={this.props.handlePrev}>
            <FontAwesomeIcon
              icon="angle-left"
              size="2x"
              color="#2C2C2E"
              style={{ marginTop: '10px', marginLeft: '20px' }}
            />
          </a>
          {/* TODO: cancel shipment */}
          <div
            className="buttonTheme-color"
            style={{
              color: '#57D7DD',
              fontSize: '24px',
              fontWeight: 700,
              textAlign: 'center'
            }}>
            {get(
              countriesData[this.props.origin],
              `name.${this.props.t('key')}`
            )}
            <img
              className="image-filter theme"
              src={ImagePlane}
              style={{
                width: '56.2px',
                paddingBottom: '2px',
                margin: '0 14px'
              }}
              alt=""
            />
            {get(
              countriesData[this.props.destination],
              `name.${this.props.t('key')}`
            )}
          </div>
          <div
            style={{
              paddingTop: '10px',
              textAlign: 'center'
            }}>
            <div style={{ display: 'inline-block', paddingRight: '10px' }}>
              {helpers.responsiveImage(
                helpers.getCarrierImage(this.props.carrier),
                helpers.getCarrierText(this.props.carrier),
                helpers.getCarrierImageWidth(this.props.carrier, 0.8)
              )}
            </div>
            <span style={{ verticalAlign: 'middle' }}>
              {this.props.carrierService.name[this.props.t('key')]}
            </span>
          </div>
          <div
            style={{
              fontSize: '12px',
              textAlign: 'center',
              padding: '12px 10px 0'
            }}>
            {this.props.t('payment.confirm_booking_1')}
            <span className="buttonSecond-color" style={{ color: '#9900A5' }}>
              {this.props.t('payment.confirm_booking_2')}
            </span>
            {this.props.t('payment.confirm_booking_3')}
          </div>
        </WrapperDiv>
        <WrapperDiv>
          <div
            style={{
              margin: '0 15px',
              padding: '20px 0px 15px',
              borderBottom: '1px solid #ccc',
              fontSize: '20px',
              fontWeight: 700
            }}>
            {this.props.t('payment.booking')}
          </div>
          <div style={{ padding: '20px 15px' }}>
            {get(this.props.pickupData, 'type') === 'NORMAL' && (
              <ShipmentRow type="flex" align="top">
                <Col span={10}>
                  {get(
                    countriesData[this.props.origin],
                    `name.${this.props.t('key')}`
                  )}
                  {this.props.t('payment.pickup_time')}
                </Col>
                <Col span={14} style={{ textAlign: 'left' }}>
                  {minDatetime.format('D MMM')} ({minDatetime.format('h:mm a')}{' '}
                  - {maxDatetime.format('h:mm a')})
                </Col>
              </ShipmentRow>
            )}
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t(
                  `payment.${
                    get(this.props.pickupData, 'type') === 'SELF_PICKUP'
                      ? 'post'
                      : 'pickup'
                  }_address`
                )}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                <AddressCard
                  t={this.props.t}
                  country={this.props.origin}
                  address={this.props.shipmentData.fromAddress}
                  expand={true}
                  pickupData={this.props.pickupData}
                />
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.receiver_address')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                <AddressCard
                  t={this.props.t}
                  country={this.props.destination}
                  address={this.props.shipmentData.toAddress}
                  expand={true}
                />
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.expected_arrived_date')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {(() => {
                  const deliveryDate = get(
                    this.props.shipmentData,
                    'deliveryDate'
                  );
                  const minDeliveryDays = get(
                    this.props.shipmentData,
                    'minDeliveryDays'
                  );
                  const maxDeliveryDays = get(
                    this.props.shipmentData,
                    'maxDeliveryDays'
                  );

                  if (deliveryDate) {
                    return moment
                      .tz(
                        get(this.props.shipmentData, 'deliveryDate'),
                        get(countriesData[this.props.destination], 'zone-name')
                      )
                      .format('D MMM h:mm a z');
                  }

                  if (minDeliveryDays && maxDeliveryDays) {
                    if (minDeliveryDays === maxDeliveryDays) {
                      return `${minDeliveryDays} ${this.props.t(
                        'common.working_day'
                      )}`;
                    }

                    return `${minDeliveryDays} - ${maxDeliveryDays} ${this.props.t(
                      'common.working_day'
                    )}`;
                  }

                  return this.props.t('common.cant_provide');
                })()}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.total_quantity')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {this.props.t('payment.box', {
                  amount: get(this.props.boxData, 'totalBox')
                })}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.estimated_total_weight')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'totalWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.estimated_weight')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'totalVolumeWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.estimated_pay_weight')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'previewWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.received_order_at')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {moment().format('D MMM h:mm a')}
              </Col>
            </ShipmentRow>
          </div>
          <InfoBar
            title={this.infoBarTitle()}
            content={this.infoBarContent()}
            t={this.props.t}
          />
        </WrapperDiv>
        <WrapperDiv>
          <div
            style={{
              padding: '20px 0px 15px',
              margin: '0 15px',
              borderBottom: '1px solid #ccc',
              fontSize: '20px',
              fontWeight: 700
            }}>
            {this.props.t('payment.estimated_fee')}
          </div>
          <div style={{ padding: '20px 15px' }}>
            <ChargeRow>
              {Math.max(
                this.props.shipmentData.totalWeight,
                this.props.shipmentData.totalVolumeWeight
              ) === this.props.shipmentData.totalVolumeWeight ? (
                <>
                  <div
                    style={{
                      backgroundColor: '#f2f2f2',
                      height: '20px',
                      padding: '3px'
                    }}>
                    <span style={{ lineHeight: '14px' }}>
                      {this.props.t('payment.calc_by_vw')}
                    </span>
                    <span
                      className="buttonSecond-color"
                      style={{
                        color: '#9900A5',
                        fontWeight: 700,
                        marginLeft: '2px',
                        lineHeight: '14px'
                      }}>
                      {get(this.props.boxData, 'totalVolumeWeight')} KG
                    </span>
                  </div>
                  <span
                    className="buttonSecond-color"
                    style={{
                      color: '#57D7DD',
                      paddingLeft: '3px',
                      cursor: 'pointer',
                      lineHeight: '20px'
                    }}
                    onClick={() => {
                      this.openStaticPopup(this.getVolumeWeightPopup());
                    }}>
                    <FontAwesomeIcon icon="question-circle" />
                  </span>
                </>
              ) : (
                <div
                  style={{
                    backgroundColor: '#f2f2f2',
                    height: '20px',
                    padding: '3px'
                  }}>
                  <span style={{ lineHeight: '14px' }}>
                    {this.props.t('payment.calc_by_w')}
                  </span>
                  <span
                    className="buttonSecond-color"
                    style={{
                      color: '#9900A5',
                      fontWeight: 700,
                      marginLeft: '2px',
                      lineHeight: '14px'
                    }}>
                    {get(this.props.boxData, 'totalWeight')} KG
                  </span>
                </div>
              )}
            </ChargeRow>
            <ChargeRow type="flex" align="bottom">
              <Col span={18}>
                {this.props.t('payment.estimated_shipping_fee')}
              </Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                {this.pricing?.current?.freightCharge?.format()}
              </Col>
            </ChargeRow>
            <ChargeRow type="flex" align="bottom">
              <Col span={18}>
                {this.props.t('payment.estimated_fuel_surcharge')}
              </Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                {this.pricing?.current?.fuelSurcharge?.format()}
              </Col>
            </ChargeRow>
            <ChargeRow type="flex" align="bottom">
              <Col span={18}>{this.props.t('payment.pickup_fee')}</Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                {this.pricing?.current?.pickupFee?.format()}
              </Col>
            </ChargeRow>
            <ChargeRow type="flex" align="bottom">
              <Col span={18}>{this.props.t('payment.other_fee')}</Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                {this.pricing?.current?.otherCharges?.format()}
              </Col>
            </ChargeRow>
            <ChargeRow type="flex" align="bottom">
              <Col span={18}>{this.props.t('payment.discount')}</Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                -{this.pricing?.current?.discount?.format()}
              </Col>
            </ChargeRow>
            <div
              style={{
                color: '#2C2C2E',
                fontSize: '12px',
                borderTop: '1px solid #ccc',
                textAlign: 'center'
              }}></div>
            <ChargeRow
              style={{
                fontWeight: 700
              }}
              type="flex"
              align="bottom">
              <Col span={18}>{this.props.t('payment.total')}</Col>
              <Col span={6} style={{ textAlign: 'right' }}>
                {this.pricing?.current?.finalRate?.format()}
              </Col>
            </ChargeRow>
          </div>
          {helpers.getCurrentCountry(true) !== 'HK' && (
            <InfoBar
              title={{ __html: this.props.t('payment.charge_with_hkd.title') }}
              content={{
                __html: this.props.t('payment.charge_with_hkd.description', {
                  price: this.pricing?.current?.finalRateInHKD?.format()
                })
              }}
            />
          )}
        </WrapperDiv>
        <CheckoutForm
          t={this.props.t}
          shipmentRef={get(this.props.shipmentData, 'shipmentRef')}
          pickupRef={get(this.props.pickupData, 'pickupRef')}
          coupon={this.state.coupon}
          discount={this.state.discount}
          shipmentData={this.props.shipmentData}
          orderRef={this.props.orderRef}
          carrier={this.props.carrier}
          routeData={{
            origin: this.props.origin,
            destination: this.props.destination,
            totalRate: get(this.props.shipmentData, 'totalRate'),
            service: this.props.service,
            shipmentRef: get(this.props.shipmentData, 'shipmentRef')
          }}
          handleRadioChange={this.handleRadioChange}
          campaign={this.props.campaign}
        />
        {this.state.popups && (
          <Popup key={!!this.state.popupKey} popups={this.state.popups} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    paymentSuccess: !!state.shipments.paymentSuccess,
    orderRef: state.shipments.orderRef,
    trackingNumber: state.shipments.trackingNumber,
    pickupNumber: state.shipments.pickupNumber,
    coupons: state.users.coupons || false,
    rates: state.shipments.rates || [],
    posts: state.shipments.posts || false,
    countries: state.shipments.countries || countries,
    paymentMethodData: state.shipments.paymentMethodData || {},
    paymentStatus: state.shipments.paymentStatus || '',
    getOrderSuccess: !!state.shipments.getOrderSuccess,
    shipment: state.shipments.shipmentData,
    transactionStatus: state.shipments.transactionStatus || null,
    props: state
  };
};

const mapDispatchToProps = {
  getInfoRequest,
  getOrderRequest
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Payment))
);
